import axios from 'axios'
import errorParser from '@/utils/error-parser'

// Verbraucher (appliances) — documentation/features/consumers.md
export default {
  listForFacility (facilityId) {
    return new Promise((resolve, reject) => {
      axios.get('/facilities/' + facilityId + '/appliances').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  listForSensorPoint (sensorId, systempart) {
    const params = systempart != null ? { systempart } : {}
    return new Promise((resolve, reject) => {
      axios.get('/cdcsensors/' + sensorId + '/appliances', { params }).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  addAppliance (facilityId, detail) {
    // detail: { name, icon, note, measurementpoints: [{ sensorid, systempart }] }
    return new Promise((resolve, reject) => {
      axios.post('/facilities/' + facilityId + '/appliances', detail).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  patchAppliance (applianceId, patch) {
    return new Promise((resolve, reject) => {
      axios.patch('/appliances/' + applianceId, patch).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  deleteAppliance (applianceId) {
    return new Promise((resolve, reject) => {
      axios.delete('/appliances/' + applianceId).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  }
}
